import { defineComponent as _defineComponent } from 'vue'
import FormLayout from '../common/FormLayout.vue'
import TicketTags from './TicketTags.vue'
import { computed, reactive } from 'vue'
import { isEqual } from 'lodash'
import Job from '../../models/job'
import { createNamespacedHelpers } from 'vuex-composition-helpers'

interface Data {
  tags: string[]
  saving: boolean
  isSnackbarVisible: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JobTagsEdit',
  props: {
    job: null,
    jobHubId: null
  },
  emits: ['tags-updated', 'dismiss'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  job: Job
  jobHubId: string
}

const ticketsStore = createNamespacedHelpers('tickets')
const { ticketsError } = ticketsStore.useState(['error'])

const jobsStore = createNamespacedHelpers('jobs')
const { updateTagsOnApprovedJob } = jobsStore.useActions([
  'updateTagsOnApprovedJob',
])



const data: Data = reactive({
  tags: props.job.tags,
  saving: false,
  isSnackbarVisible: false,
})

const hasChanges = computed<boolean>(() => {
  return !isEqual(data.tags, props.job.tags)
})

const updateTags = (value: string[]) => {
  data.tags = value
}



const save = async () => {
  data.saving = true
  await updateTagsOnApprovedJob({
    jobId: props.job.id,
    tags: data.tags,
  })
  data.saving = false

  if (ticketsError) {
    data.isSnackbarVisible = true
  } else {
    emits('tags-updated')
    dismiss()
  }
}

const dismiss = () => {
  emits('dismiss')
}

return { __sfc: true,ticketsStore, ticketsError, jobsStore, updateTagsOnApprovedJob, props, data, hasChanges, updateTags, emits, save, dismiss, FormLayout, TicketTags }
}

})